import { useSecureGraphqlMutation } from '@psyomics/ui-common';

import {
  CreateReferralRequestDocument,
  CreateReferralRequestInput,
  CreateReferralRequestMutation,
  CreateReferralRequestMutationVariables,
} from '../generated/referral-request';

const useCreateReferralRequest = () => {
  const [{ data, fetching, errorMessage }, executeMutation] = useSecureGraphqlMutation<
    CreateReferralRequestMutation,
    CreateReferralRequestMutationVariables
  >(CreateReferralRequestDocument);

  const createReferralRequest = (input: CreateReferralRequestInput) => executeMutation({ input });
  const result = data?.createReferralRequest;

  return { createReferralRequest, errorMessage, fetching, result, submitted: Boolean(result) };
};

export { useCreateReferralRequest };
